import { createContext, useContext, type ReactNode } from "react";
import { getBrowserIanaTimeZoneId } from "@schema-types/enquiryEvaluationTimeZone";

const EnquiryEvaluationTimeZoneContext = createContext<string | null>(null);

export function EnquiryEvaluationTimeZoneProvider({
  timeZoneId,
  children,
}: {
  timeZoneId: string | null | undefined;
  children: ReactNode;
}) {
  return (
    <EnquiryEvaluationTimeZoneContext.Provider value={timeZoneId?.trim() || null}>
      {children}
    </EnquiryEvaluationTimeZoneContext.Provider>
  );
}

/** IANA id stored on the enquiry, or browser default when unset (e.g. preview). */
export function useEnquiryEvaluationTimeZoneId(): string {
  const stored = useContext(EnquiryEvaluationTimeZoneContext);
  return (stored && stored.length > 0 ? stored : null) ?? getBrowserIanaTimeZoneId();
}
